<template>

  <div id="page-user-list">

    <div class="vx-card p-6" v-show="loaded">

      <!-- Header -->
      <div class="flex justify-between flex-wrap items-center">

        <!-- Search Form -->
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />

        <!-- Button Add -->
        <vs-button color="primary" icon-pack="feather" icon="icon-plus" class="mr-4" @click="addItem">Add Item</vs-button>

      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="itemsData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <!-- Pagination -->
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full">
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ itemsData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : itemsData.length }} of {{ itemsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <!-- PAGINATION -->
          <vs-pagination
            :total="totalPages"
            :max="7"
            v-model="currentPage" />
        </div>
      </div>
    </div>

    <!--  Popup Account  -->
    <vs-popup classContent="popup-example" :title="`${mode} item`" :active.sync="popup">

      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full">
          <small class="mb-1">{{ $i18n.t('Role') }}</small>
          <ul class="center mt-1 mb-3" style="display: flex; ">
            <li class="mr-3">
              <vs-radio v-model="form.role" vs-value="Administrator">Administrator</vs-radio>
            </li>
            <li class="mr-3">
              <vs-radio v-model="form.role" vs-value="level 1">Level 1</vs-radio>
            </li>
            <li class="mr-3">
              <vs-radio v-model="form.role" vs-value="level 2">Level 2</vs-radio>
            </li>
            <li class="mr-3">
              <vs-radio v-model="form.role" vs-value="level 3">Level 3</vs-radio>
            </li>
            <li class="mr-3">
              <vs-radio v-model="form.role" vs-value="level 4">Level 4</vs-radio>
            </li>
            <li>
              <vs-radio v-model="form.role" vs-value="level 5">Level 5</vs-radio>
            </li>
          </ul>
        </div>

        <div class="vx-col md:w-6/12">
          <vs-input class="w-full mb-3" :label="$i18n.t('Username')" v-model="form.username" />
        </div>

        <div class="vx-col md:w-6/12">
          <vs-input class="w-full mb-3" :label="$i18n.t('Email')" v-model="form.email" />
        </div>

        <div class="vx-col md:w-6/12">
          <vs-input v-show="mode === 'add'" type="password" class="w-full mb-3" :label="$i18n.t('Password')" v-model="form.password" />
        </div>

        <div class="vx-col md:w-6/12">
          <vs-input v-show="mode === 'add'" type="password" class="w-full mb-3" :label="$i18n.t('PasswordConfirmation')" v-model="form.password_confirmation" />
        </div>

        <div class="vx-col md:w-6/12">
          <vs-input class="w-full mb-3" :label="$i18n.t('Name')" v-model="form.nama" />
        </div>

        <div class="vx-col md:w-6/12">
          <vs-input class="w-full mb-3" :label="$i18n.t('Phone')" v-model="form.telepon" />
        </div>

        <div class="vx-col md:w-6/12">
          <label class="vs-input--label">{{$i18n.t('DateofBirth')}}</label>
          <datepicker format="d/MM/yyyy" :value="form.tanggal_lahir" @input="form.tanggal_lahir = $moment($event)"></datepicker>
        </div>

        <div class="vx-col md:w-6/12">
          <vs-input class="w-full mb-3" :label="$i18n.t('Position')" v-model="form.jabatan" />
        </div>

        <div class="vx-col md:w-1/1 w-full">
          <small class="mb-1">{{ $i18n.t('Gender') }}</small>
          <ul class="centerx mt-1 mb-3" style="display: flex; ">
            <li class="mr-3">
              <vs-radio v-model="form.jenis_kelamin" vs-value="Laki-Laki">{{ $i18n.t('Male') }}</vs-radio>
            </li>
            <li>
              <vs-radio v-model="form.jenis_kelamin" vs-value="Perempuan">{{ $i18n.t('Female') }}</vs-radio>
            </li>
          </ul>
        </div>

        <div class="vx-col md:w-1/1 w-full">
          <label for="description" class="vs-input--label">{{$i18n.t('Address')}}</label>
          <vs-textarea id="description" rows="6" class="w-full mb-3" v-model="form.alamat" />
        </div>
      </div>

      <div class="mt-5">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-save" @click="storeItem">
          {{ $i18n.t('Save') }}
        </vs-button>
      </div>

    </vs-popup>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import Datepicker from "vuejs-datepicker";
import moment from 'moment';

import axios from '@/axios';

// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import CellRendererFile from './cell-renderer/CellRendererFile.vue'


export default {
  components: {
    AgGridVue,
    vSelect,
    Datepicker,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    CellRendererFile
  },
  data () {
    return {
      loaded: false,
      searchQuery: '',
      year: '2017',
      form:{},

      // AgGrid
      popup: false,
      gridApi: null,
      gridOptions: {},
      itemsData: [],
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: this.$i18n.t('Username'),
          field: 'username',
          filter: true,
          width: 200,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellClass: 'text-center'
        },
        {
          headerName: this.$i18n.t('Employee'),
          field: 'nama',
          filter: true,
          width: 350,
        },
        {
          headerName: 'Action',
          width: 120,
          cellRendererFramework: 'CellRendererActions',
          cellRendererParams: {
            editItem: this.editItem.bind(this),
            deleteItem: this.deleteItem.bind(this)
          },
          cellClass: 'text-center'
        }
      ],
    }
  },
  computed: {
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    loading () {
      this.loaded = false;

      this.$vs.loading({
        type: 'border',
        color: 'primary',
        text: `Wait a minute, It's getting data.`
      })
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },

    // get all data accounts
    getData(){
      axios.get('/sales/user').then(resp => this.itemsData = resp.data ).catch(err => {
        this.$vs.notify({
          title:'Oops something error',
          text: err.data.message,
          color:'danger'
        })
      })
      .finally(() => {
        this.onLoaded();
      })
    },

    // trigger when user click add
    addItem(){
      this.mode = 'add'
      this.popup = true
    },

    // edit item
    editItem (item) {
      this.popup = true;
      this.mode = 'edit';
      this.itemSelected = item;

      this.form = {
        username: item.username,
        email: item.email === '-' ? '' : item.email,
        jabatan: item.jabatan,
        role: item.role,
        nama: item.nama,
        alamat: item.alamat,
        tanggal_lahir: item.tanggal_lahir,
        jenis_kelamin: item.jenis_kelamin,
        telepon: item.telepon,
      };
    },

    storeItem(){
      if(this.mode == 'add'){
        let body = this.form

        axios.post('/sales/user', body).then(resp => {
          this.popup = false;

          this.$swal({
            title: 'Successful',
            text: resp.data.message,
            icon: 'success'
          }).then(() => {
            this.getData();
            this.form = {}
          });
        }).catch(err => {
          this.$vs.notify({
            title:'Opps something error',
            text: err.data.message,
            color:'danger'
          })
        })
      }

      else if (this.mode == 'edit') {
        let body = Object.assign(this.form, { _method: 'PUT' })

        axios.post('/sales/user/' + this.itemSelected.id, body).then(resp => {
          this.popup = false;

          this.$swal({
            title: 'Successful',
            text: resp.data.message,
            icon: 'success'
          }).then(() => {
            this.getData();
            this.form = {}
          });
        }).catch(err => {
          this.$vs.notify({
            title:'Opps something error',
            text: err.data.message,
            color:'danger'
          })
        })
      }

      this.mode = ''
    },

    deleteItem (item) {
      axios.delete('/sales/user/' + item.id).then(resp => {
        this.$swal({
          title: 'Successful',
          text: resp.data.message,
          icon: 'success'
        }).then(() => {
          this.getData();
        });
      }).catch(err => {
        this.$vs.notify({
          title:'Opps something error',
          text: err.data.message,
          color:'danger'
        })
      })
    },

    onLoaded(){
      this.loaded = true;
      this.$vs.loading.close();
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  created () {
    this.loading();
    // call method getData
    this.getData()
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
